/* eslint-disable import/prefer-default-export */
import { regExpAccents, regExpLettersAccents, unicode } from './constants';

export const searchOverQuestion = (questionTitle: string, input: string) => {
  if (!questionTitle || input === null || input === undefined) {
    return false;
  }
  
  return regExpLettersAccents.test(input)
    ? questionTitle.toLowerCase().includes(input.toLowerCase())
    : questionTitle
        .toLowerCase()
        .normalize(unicode)
        .replace(regExpAccents, '')
        .includes(input.toLowerCase());
};
